import React from "react";
import { Link } from "react-router-dom";

export default function DynamicBreadcrumb({ breadcrumbData }) {
 
  return (
    <>
      <section className="dynamic-breadcrumb-area header-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <ul className="dynamic-breadcrumb">
                {breadcrumbData?.map((data, index) => (
                  <li key={index}>
                    <Link to={data.slug}>{data.page}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
